import { Tabs, Layout, Text } from '@loadsmart/miranda-react'

import { formatDate } from 'core/utils/date'

import type { ShipperDetail } from '../../../domain/shippers'

export type ShipperDetailsTabProps = {
  details: ShipperDetail
}

export function ShipperDetailsTab({ details }: ShipperDetailsTabProps) {
  return (
    <>
      <Tabs.Tab name="details">Details</Tabs.Tab>
      <Tabs.Panel forTab="details">
        <Layout.Box
          backgroundColor="color-background-primary"
          borderColor="color-border"
          borderWidth="border-thin"
          borderRadius="border-radius-s"
          padding="spacing-4"
        >
          <Layout.Group gap="spacing-4" align="center">
            <Text variant="body-md" color="color-text-tertiary">
              Date added
            </Text>
            <Text variant="body-md" color="color-text-primary">
              {formatDate(details.carrierAddedAt, 'MMM dd, yyyy')}
            </Text>
          </Layout.Group>
        </Layout.Box>
      </Tabs.Panel>
    </>
  )
}
